/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue } from '../../../../../Fct/generics';
import { ROUTER_ADDRESSES } from '../../constants';
export var params = {
    input: {
        to: new FctAddress({ destination: 'sushiswap_router' }),
        value: new FctValue({ destination: 'wei_amount' }),
        methodParams: {
            token: new FctAddress({ destination: 'erc20' }),
            amountTokenDesired: new FctValue({ destination: 'wei_amount' }),
            amountTokenMin: new FctValue({ destination: 'wei_amount' }),
            amountETHMin: new FctValue({ destination: 'wei_amount' }),
            to: new FctAddress({}),
            deadline: new FctTimestamp({}),
        },
    },
    output: {
        amountA: new FctValue({ innerIndex: 0, destination: 'wei_amount' }),
        amountB: new FctValue({ innerIndex: 1, destination: 'wei_amount' }),
        liquidity: new FctValue({ innerIndex: 2, destination: 'wei_amount' }),
    },
};
export var AddLiquidityETH = createPlugin({
    protocol: 'SUSHISWAP',
    type: 'ACTION',
    method: 'addLiquidityETH',
    description: 'Add liquidity on Sushiswap',
    supportedContracts: ROUTER_ADDRESSES,
    getParams: function () { return params; },
    initParams: {
        methodParams: {
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
    requiredApprovals: function (params) {
        return [
            {
                to: params === null || params === void 0 ? void 0 : params.methodParams.token.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.amountTokenDesired.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
